import React, { useEffect } from "react";
import {
  Box,
  Flex,
  Grid,
  GridItem,
  Image,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
  Portal,
  Text,
  Icon,
} from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { NavLink } from "react-router-dom";

function CategoryBar() {
  useEffect(() => {
    localStorage.removeItem("cids");
  }, []);
  const categories = [
    {
      image: "headerLogos/8.jpg",
      title: "Lawyers Clothing & Accessories",
      badge: "Apparel",
      page: "/products?maincat=Cloths-Accessories",
      submenu: [
        { title: "Lawyer Coats & Blazers", page: "/products?maincat=Cloths-Accessories&subcatname=Coat" },
        { title: "Advocate Jackets", page: "/products?maincat=Cloths-Accessories&subcatname=Jacket" },
        { title: "Judicial & High Court Gowns", page: "/products?maincat=Cloths-Accessories&subcatname=Gown" },
        { title: "Bands, Ties & Accessories", page: "/products?maincat=Cloths-Accessories&subcatname=Accessories" },
      ],
    },
    {
      image: "headerLogos/3.jpg",
      title: "Legal Research Software",
      badge: "Software",
      page: "/software",
      submenu: [
        { title: "Supreme Today AI", page: "/supremeAi" },
        { title: "CDJ Law Journal", page: "/CDJLawJournal" },
        { title: "Digilegal Online", page: "/digileagal" },
        { title: "LegitQuest AI", page: "/LegitQuest" },
        { title: "DLT Publications Online", page: "/DltPublications" },
        { title: "Taxmann Law Suite", page: "/taxman" },
      ],
    },
    {
      image: "headerLogos/6.jpg",
      title: "Paralegal Research Partner",
      badge: "Service",
      page: "/leagleReaserch",
      submenu: [],
    },
    {
      image: "headerLogos/4.jpg",
      title: "Litigation Management (LMS)",
      badge: "Cloud SaaS",
      page: "/lms",
      submenu: [],
    },
    {
      image: "headerLogos/5.jpg",
      title: "Dictation & Translation",
      badge: "AI Speech",
      page: "/dandt",
      submenu: [],
    },
    {
      image: "headerLogos/1.jpg",
      title: "Law Book Store",
      badge: "Publications",
      page: "/products?maincat=Books",
      submenu: [
        { title: "All Law Books & Bare Acts", page: "/products?maincat=Books" },
        { title: "Law Journals & Bound Volumes", page: "/products?maincat=Journals" },
        { title: "E-Books & Digital Editions", page: "/products?maincat=E-Books" },
      ],
    },
    {
      image: "https://png.pngtree.com/recommend-works/png-clipart/20241011/ourmid/pngtree-3d-gavel-with-right-sign-law-and-justice-concept-png-image_14075430.png",
      title: "Curated Recommendations",
      badge: "Featured",
      page: "/RecommendedLink",
      submenu: [],
    },
  ];

  return (
    <Box
      bg="#FFFFFF"
      borderBottom="1px solid #E2E8F0"
      shadow="0 2px 8px -2px rgba(15, 23, 42, 0.05)"
      display={{ base: "none", md: "block" }}
      py="2.5"
    >
      <Box maxW="1360px" mx="auto" px={{ md: "4", lg: "6" }}>
        <Grid
          templateColumns="repeat(7, 1fr)"
          gap={{ md: "2", lg: "4" }}
          alignItems="stretch"
        >
          {categories.map((item, index) => {
            const hasSubmenu = item.submenu && item.submenu.length > 0;

            const categoryContent = (
              <Box
                h="100%"
                p={{ md: "2", lg: "2.5" }}
                rounded="xl"
                textAlign="center"
                cursor="pointer"
                transition="all 0.2s cubic-bezier(0.16, 1, 0.3, 1)"
                border="1px solid transparent"
                _hover={{
                  bg: "gray.50",
                  borderColor: "gray.200",
                  transform: "translateY(-2px)",
                  shadow: "0 6px 14px -3px rgba(15, 23, 42, 0.08)",
                }}
                role="group"
              >
                <Box
                  w={{ md: "48px", lg: "54px" }}
                  h={{ md: "48px", lg: "54px" }}
                  mx="auto"
                  mb="2"
                  p="1.5"
                  rounded="xl"
                  bg="gray.50"
                  border="1px solid #F1F5F9"
                  _groupHover={{ bg: "#EFF6FF", borderColor: "#BFDBFE" }}
                  transition="all 0.2s"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Image
                    src={item.image}
                    alt={item.title}
                    maxH="100%"
                    maxW="100%"
                    objectFit="contain"
                    transition="transform 0.2s"
                    _groupHover={{ transform: "scale(1.08)" }}
                  />
                </Box>
                <Flex align="center" justify="center" gap="1">
                  <Text
                    fontSize={{ md: "11px", lg: "12.5px" }}
                    fontWeight="600"
                    color="gray.700"
                    lineHeight="1.25"
                    _groupHover={{ color: "#1D4ED8" }}
                    noOfLines={2}
                  >
                    {item.title}
                  </Text>
                  {hasSubmenu && (
                    <ChevronDownIcon
                      boxSize="13px"
                      color="gray.400"
                      _groupHover={{ color: "#1D4ED8", transform: "rotate(180deg)" }}
                      transition="transform 0.2s"
                    />
                  )}
                </Flex>
              </Box>
            );

            if (hasSubmenu) {
              return (
                <GridItem key={index}>
                  <Popover
                    trigger="hover"
                    placement="bottom-start"
                    openDelay={0}
                    closeDelay={120}
                    gutter={4}
                  >
                    <PopoverTrigger>
                      <Box as="div" h="100%">
                        <NavLink to={item.page} style={{ height: "100%", display: "block" }}>
                          {categoryContent}
                        </NavLink>
                      </Box>
                    </PopoverTrigger>
                    <Portal>
                      <PopoverContent
                        w="250px"
                        bg="#FFFFFF"
                        border="1px solid #E2E8F0"
                        rounded="xl"
                        shadow="0 20px 40px -4px rgba(15, 23, 42, 0.22)"
                        py="2"
                        _focus={{ boxShadow: "none" }}
                        zIndex="2000"
                        transition="opacity 0.1s ease, transform 0.1s ease"
                      >
                        <PopoverArrow bg="#FFFFFF" />
                        <PopoverBody p="1.5">
                          <Text px="3" py="1" fontSize="11px" fontWeight="bold" textTransform="uppercase" color="gray.400">
                            {item.badge}
                          </Text>
                          {item.submenu.map((sub, sIdx) => (
                            <NavLink key={sIdx} to={sub.page}>
                              <Box
                                px="3"
                                py="2"
                                rounded="lg"
                                fontSize="13px"
                                fontWeight="500"
                                color="gray.700"
                                _hover={{ bg: "#EFF6FF", color: "#1D4ED8" }}
                                transition="background 0.15s"
                              >
                                {sub.title}
                              </Box>
                            </NavLink>
                          ))}
                        </PopoverBody>
                      </PopoverContent>
                    </Portal>
                  </Popover>
                </GridItem>
              );
            }

            return (
              <GridItem key={index}>
                <NavLink to={item.page} style={{ height: "100%", display: "block" }}>
                  {categoryContent}
                </NavLink>
              </GridItem>
            );
          })}
        </Grid>
      </Box>
    </Box>
  );
}

export default CategoryBar;